






















import { Component, Vue } from 'vue-property-decorator';
import storage from '../utils/storage';
@Component({
  components: {
  },
})
export default class ManageAsin extends Vue {
  private headers: any = {
    authorization: 'authorization-text',
  };
  private spinning: boolean = false;
  private handleChange(info: any) {
    if (info.file.status !== 'uploading') {
      // console.log(info.file, info.fileList);
    }
    if (info.file.status === 'done') {
      this.$message.success(`${info.file.name} file ${info.file.response.num} Orders uploaded successfully`);
      // console.log(info);
    } else if (info.file.status === 'error') {
      this.$message.error(`${info.file.name} file ${info.file.response.msg} upload failed.`);
    }
  }
  // 下载orderID 模板
  private getManageAsinTemplate() {
    this.spinning = true;
    const that = this;
    const args = {};
    this.axios.post('/api/getManageAsinTemplate', args , { responseType: 'blob'}).then((res) => {
      that.downloadFile(res.data, 'manageAsin.csv');
    });
  }
  // 下载文件 方法 传入blob数据,和 定义的文件名称
  private downloadFile(data: any, fileName: any) {
    if (!data) {
      return;
    }
    const url = window.URL.createObjectURL(new Blob([data]));
    const link = document.createElement('a');
    link.style.display = 'none';
    link.href = url;
    // 获取文件名
    // download 属性定义了下载链接的地址而不是跳转路径
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    this.spinning = false;
  }
}
